import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar';
import { faIndustry } from '@fortawesome/free-solid-svg-icons';
import { faRobot, faGraduationCap, faNetworkWired } from '@fortawesome/free-solid-svg-icons';


const timelineData = [
    {
        date: "Aug 2025 - Present",
        title: "Backend Engineer at ",
        organization: "Mercedes-Benz.io",
        location: "Braga, Portugal",
        description: <ul>
            <li> &gt; Working on the backend side of Mercedes-Benz's e-commerce operations.</li>
        </ul>,
        skils: ['Spring Boot', 'Java', 'Kubernetes', 'Postgres', 'Python'],
        icon: <FontAwesomeIcon icon={faIndustry} />
    },
    {
        date: "Feb 2025 - Jul 2025",
        title: "Master's Thesis at ",
        organization: "ZAAI",
        location: "Porto, Portugal",
        description: <ul>
            <li> &gt; Researched and designed Mixture-of-Experts deep learning architectures to improve time series forecasting across heterogeneous datasets. </li>
        </ul>,
        skils: ['PyTorch', 'Python', 'Nixtla'],
        icon: <FontAwesomeIcon icon={faRobot} />
    },
    {
        date: "Jul 2024 - Sep 2024",
        title: "Summer Internship at ",
        organization: "Critical Manufacturing",
        location: "Porto, Portugal",
        description: <ul>
            <li> &gt; Developed an Azure DevOps extension to automate capacity adjustments, manage time off, and integrate sprint planning templates, reducing sprint planning time and improving consistency within teams in scaled Agile.</li>
        </ul>,
        skils: ['React', 'TypeScript', 'Azure DevOps'],
        icon: <FontAwesomeIcon icon={faIndustry} />
    },
    {
        date: "Feb 2024 - Jul 2024",
        title: "Academic Project for ",
        organization: "ZAAI",
        location: "Porto, Portugal",
        description: <ul>
            <li> &gt; Led development efforts for both the frontend and retrieval system of a retrieval-augmented generation platform.</li>
            <li> &gt; Focused on enhancing search functionality within corporate documentation.</li>
        </ul>,
        skils: ['Faiss', 'React', 'Node.js', 'Mongodb', 'Express'],
        icon: <FontAwesomeIcon icon={faRobot} />
    },
    {
        date: "Feb 2024 - Jul 2024",
        title: "Classroom Assistant at ",
        organization: "Universidade do Porto",
        location: "Porto, Portugal",
        description: <ul>
            <li> &gt; Assisted peers in the compilers classroom by offering support in both theoretical concepts and practical project.</li>
        </ul>,
        skils: ['Java'],
        icon: <FontAwesomeIcon icon={faGraduationCap} />
    },
    {
        date: "Feb 2023 - Jul 2023",
        title: "Academic Project for ",
        organization: "Altice Labs",
        location: "Porto, Portugal",
        description: <ul>
            <li> &gt; Designed and developed a multi-channel notification micro-service aimed at swiftly responding to service failures by
                issuing notifications across multiple channels, facilitating rapid troubleshooting.</li>
            <li> &gt; Integration across diverse communication channels, including Microsoft Teams, WhatsApp, Email and SMS</li>
        </ul>,
        skils: ['Quarkus', 'Java', "Postgres"],
        icon: <FontAwesomeIcon icon={faNetworkWired} />
    },
    {
        date: "Feb 2023 - Jul 2023",
        title: "Classroom Assistant at ",
        organization: "Universidade do Porto",
        location: "Porto, Portugal",
        description: <ul>
            <li> &gt; Provided support to both the classroom and the instructor in a C-based driver development class.</li>

        </ul>,
        skils: ['C', 'Minix'],
        icon: <FontAwesomeIcon icon={faGraduationCap} />
    }
];

const Timeline = () => {
    return (
        <VerticalTimeline lineColor='#758edf'>
            {timelineData.map((item, index) => (
                <VerticalTimelineElement
                    key={index}
                    className="vertical-timeline-element--work"
                    contentStyle={{ background: '#5a6dd1', color: '#04614f' }}
                    contentArrowStyle={{ borderRight: '7px solid #5a6dd1' }}
                    date={item.date}
                    iconStyle={{ background: '#04614f', color: '#fff' }}
                    icon={item.icon}
                >
                    <h3 className="vertical-timeline-element-title text-primary-400 inline">{item.title}</h3>
                    <span className='font-bold ' style={{
                        backgroundImage: 'linear-gradient(to top left, #fefefe, #e4eefb)',
                        WebkitBackgroundClip: 'text',
                        color: 'transparent',
                        fontSize: '1.3rem'
                    }}>
                        {item.organization}
                    </span>
                    <h4 className="vertical-timeline-element-subtitle text-primary-400">{item.location}</h4>
                    <p className='text-primary-50'>
                        {item.description}
                    </p>
                    <div className={`flex flex-row justify-left mt-2 `}>
                        {item.skils.map((skill, index) => (
                            <span key={`${index}`} className='inline-block bg-red-500 text-primary-400 px-2 py-1 rounded-full border-2 ml-2 hover:bg-secondary-100'>{skill}</span>
                        ))}
                        {/* TODO: REFACTOR THIS ... duplicated code */}
                    </div>

                </VerticalTimelineElement>
            ))}
            <VerticalTimelineElement
                iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                icon={<FontAwesomeIcon icon={faStar} />}
            />
        </VerticalTimeline>
    );
}

export default Timeline;
